import { SnackbarProvider } from 'notistack';
import type { ReactNode } from 'react';

interface NotificationsProviderProps {
  children: ReactNode;
}

export function NotificationsProvider({ children }: NotificationsProviderProps): JSX.Element {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={5000}
      preventDuplicate
    >
      {children}
    </SnackbarProvider>
  );
}
